/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PasswordChange
 */
export interface PasswordChange {
    /**
     * 
     * @type {string}
     * @memberof PasswordChange
     */
    old_password: string;
    /**
     * 
     * @type {string}
     * @memberof PasswordChange
     */
    new_password: string;
}

/**
 * Check if a given object implements the PasswordChange interface.
 */
export function instanceOfPasswordChange(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "old_password" in value;
    isInstance = isInstance && "new_password" in value;

    return isInstance;
}

export function PasswordChangeFromJSON(json: any): PasswordChange {
    return PasswordChangeFromJSONTyped(json, false);
}

export function PasswordChangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordChange {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'old_password': json['old_password'],
        'new_password': json['new_password'],
    };
}

export function PasswordChangeToJSON(value?: PasswordChange | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'old_password': value.old_password,
        'new_password': value.new_password,
    };
}

